import { documentsEffects } from './index';

documentsEffects.deleteDocument.doneData.watch(() => {
    documentsEffects.getDocuments(null);
});
